import { render, staticRenderFns } from "./import_record.vue?vue&type=template&id=b0c50d0c&scoped=true&"
import script from "./import_record.vue?vue&type=script&lang=ts&"
export * from "./import_record.vue?vue&type=script&lang=ts&"
import style0 from "./import_record.vue?vue&type=style&index=0&id=b0c50d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c50d0c",
  null
  
)

export default component.exports